import { LeaveDurationTypeEnum } from '../../../commonTypes/leaveRequest.types';
import { diffDaysWithoutWeekendsAndHolidays } from '../../../util/date/dateHelper';
import { DateTime } from 'luxon';
import { HolidayDto } from '../../../commonTypes/organization.types';
import { UserOrganizationPolicyDto } from '../../../commonTypes/acs/user.types';

export const calculateDaysAroundLimit = (
    fromDate: DateTime,
    toDate: DateTime,
    policy: UserOrganizationPolicyDto,
    holidays?: HolidayDto[],
    disabledDays?: DateTime[]
) => {
    const policyLimit = DateTime.fromObject(
        {
            day: policy.carriedOverValidToDay,
            month: policy.carriedOverValidToMonth,
            year: DateTime.now().year,
        },
        { zone: fromDate.zone }
    ).startOf('day');

    let daysIncludingLimit = 0;
    let daysAfterLimit = 0;

    if (toDate <= policyLimit) daysIncludingLimit = diffDaysWithoutWeekendsAndHolidays(fromDate, toDate, holidays, disabledDays);
    else if (fromDate <= policyLimit) {
        daysIncludingLimit = diffDaysWithoutWeekendsAndHolidays(fromDate, policyLimit, holidays, disabledDays);
        daysAfterLimit = diffDaysWithoutWeekendsAndHolidays(policyLimit.plus({ days: 1 }), toDate, holidays, disabledDays);
    } else daysAfterLimit = diffDaysWithoutWeekendsAndHolidays(fromDate, toDate, holidays, disabledDays);

    return { daysIncludingLimit, daysAfterLimit };
};

/**
 *
 * @param fromDate - start of interval
 * @param toDate - end of interval
 * @param policy - policy of a request
 * @returns newAmount and newCarriedOver amount that is caluclated based on subtracitg, it means it is used when requesting a new leave.
 */
export const calculateNewAmountsBySubtracting = (
    fromDate: DateTime,
    toDate: DateTime,
    policy: UserOrganizationPolicyDto,
    leaveDurationType: LeaveDurationTypeEnum,
    holidays?: HolidayDto[],
    disabledDays?: DateTime[]
) => {
    let diffDays = diffDaysWithoutWeekendsAndHolidays(fromDate, toDate, holidays, disabledDays);
    const isHalfDay = leaveDurationType === LeaveDurationTypeEnum.FIRST_DAY_HALF || leaveDurationType === LeaveDurationTypeEnum.SECOND_DAY_HALF;
    if (isHalfDay) diffDays /= 2;
    let newAmount = policy.amount - diffDays;
    let newCarriedOverAmount = policy.carriedOverAmount;
    let newMaximumNegativeAmount = policy.maximumNegativeAmount;

    if (policy.isCarriedOver) {
        let { daysIncludingLimit, daysAfterLimit } = calculateDaysAroundLimit(fromDate, toDate, policy, holidays, disabledDays);
        if (isHalfDay) {
            daysIncludingLimit /= 2;
            daysAfterLimit /= 2;
        }
        newAmount = policy.amount - daysAfterLimit;
        newCarriedOverAmount = 0;

        if (policy.carriedOverAmount < daysIncludingLimit) newAmount = newAmount - (daysIncludingLimit - policy.carriedOverAmount);
        else newCarriedOverAmount = policy.carriedOverAmount - daysIncludingLimit;
    }

    return { newAmount, newCarriedOverAmount, newMaximumNegativeAmount };
};
